import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { ITableModel } from '../table/model/tableModel';
import { Helpers } from '../../../helpers';
import { Router } from '@angular/router';
import { appService } from '../../../_services/app.service';
import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';
import { CommonService } from '../../../_services/common.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-return-sales-order-transaction-component',
  templateUrl: './return-sales-order-transaction-component.component.html',
  styleUrls: ['./return-sales-order-transaction-component.component.scss']
})
export class ReturnSalesOrderTransactionComponentComponent implements OnInit {

  static that: ReturnSalesOrderTransactionComponentComponent;
  tableDetails: ITableModel;
  totalCount: number = 0;
  noOfPages: number = 15;
  searchValue: string = '';
  filterObj: any = {
    Status: 'All'
  };
  payload: any = {};
  @Input() Id: any;
  @Input() referenceType: any;
  @Input() headerName: any;

  @Input() shipmentModetypearray: any = [];
  @Input() parentTypearray: any = [];

  data: any = {};
  reportHeader: any = [];
  TenantId: any;
  CompanyId: any;
  userId: any;

  FromDate: any = {
    formControlName: 'FromDate',
    dataField: 'FromDate',
    placeholder: 'Select FromDate'
  };
  ToDate: any = {
    formControlName: 'ToDate',
    dataField: 'ToDate',
    placeholder: 'Select ToDate'
  };
  searchFieldDetails: any = {
    placeholder: "Search",
    type: "text",
    isSearchBox: true,
  };
  constructor(
    private router: Router,
    private _appService: appService,
    private toastr: ToastrService,
    private cookieService: CookieService,
    private decryptpipe: DecryptPipe,
    private commonService: CommonService,
    private datePipe: DatePipe,
  ) {
    ReturnSalesOrderTransactionComponentComponent.that = this;
  }

  ngOnInit() {
    this.TenantId = JSON.parse(
      this.decryptpipe.transform(JSON.parse(this.cookieService.get("TenantId"))));
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    const storedPerPage = localStorage.getItem('perPage');
    if (storedPerPage) {
      this.noOfPages = parseInt(storedPerPage, 10);
    }
    const currentDate = new Date();
    const firstDateOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);


    this.data[this.ToDate.dataField] = this.datePipe.transform(new Date(), 'dd-MMM-yyyy');
    this.data[this.FromDate.dataField] = this.datePipe.transform(firstDateOfMonth, 'dd-MMM-yyyy');

    this.initalizeForm();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['Id']) {
      this.Id = changes['Id'].currentValue;
      if (this.Id) {
        // this.GetTransactionList('', 0, {}, this.noOfPages, this.Id)
      }
    }
  }

  async initalizeForm() {
    this.tableDetails = {
      data: [],
      emptyDataMSg: 'Orders not added yet. Please add orders.',
      isColumnNameShow: true,
      columnDetails: [
        { columnName: 'Orders.OrderNo', dataFieldName: 'Order No', dataFieldName2: 'Order Date', divType: 'ftlOrders', color: 'var(--colors-primary-blue-blue-200, #3367FB)' },
        { columnName: "Orders.ReferenceNo", dataFieldName: 'Reference No' },
        { columnName: "Orders.Customer", dataFieldName: 'Customer', dataFieldName2: 'Pickup Location Code', },
        { columnName: 'Ship To Party', dataFieldName: 'Ship To Party', dataFieldName2: 'Delivery Location Code', },
        { columnName: 'Qty in Case', dataFieldName: 'CaseQty', divType: '' },
        { columnName: 'Total Qty', dataFieldName: 'totalQty', divType: '', alignType: 'right' },
        { columnName: 'Weight', dataFieldName: 'totalWeight', divType: '', alignType: 'right' },
        { columnName: "Orders.Amount", dataFieldName: 'Amount', alignType: 'right' },
        { columnName: 'Orders.Status', dataFieldName: 'Order Status', divType: 'status' },
      ]
    }
  }

  getChangedValue(value, data) {
    if (data.dataField == 'FromDate') {
      if (value != null) {
        this.data[this.FromDate.dataField] = value;
      }
    }
    if (data.dataField == 'ToDate') {
      if (value != null) {
        this.data[this.ToDate.dataField] = value;
        // this.GetTransactionList('', 0, {}, this.noOfPages, this.Id)
      }
    }
  }

  GetTransactionList(
    searchValue = this.searchValue,
    pageNo: number = 0,
    filterObject: any = this.filterObj,
    perPage: any = this.noOfPages,
    Id,
    CompanyId

  ) {

    Helpers.setLoading(true);

    this.payload.PageNo = pageNo * perPage;
    this.payload.PerPage = perPage;
    this.payload.SearchValue = searchValue;
    this.payload.CompanyId = (CompanyId !== undefined && CompanyId !== null) ? CompanyId : this.CompanyId;
    this.payload.OrderNo = null;

    if (this.parentTypearray.includes('supplier') || this.parentTypearray.includes('manufacturer') || this.parentTypearray.includes('General Trade') || this.parentTypearray.includes('Customer')) {
      this.payload.SupplierName = Id ? Id : this.Id;
    }
    else {
      this.payload.SupplierName = null;
    }

    this.payload.ShipTo = null;
    this.payload.AllocationStatus = null;
    this.payload.FromDate = this.data.FromDate;
    this.payload.ToDate = this.data.ToDate;
    this.payload.Status = null;
    this.payload.UserId = this.userId;

    if (this.referenceType == 'Users') {
      this.payload.salesPersonId = Id ? Id : this.Id;
    }
    else {
      this.payload.salesPersonId = null;
    }

    this.payload.tabId = Id ? Id : this.Id;
    this.payload.tabreferenceType = this.referenceType;

    this._appService.Post("so_GoodsOutward", "so_rtn_GetOrdersList", this.payload).subscribe((response) => {
      if (response.length) {
        this.totalCount = response[0].recordcount;
      }
      this.assignTableFields(pageNo, perPage, response);
      Helpers.setLoading(false);
    },
      (err) => {
        Helpers.setLoading(false);
        this.toastr.error("Error while fetching data", err);
      }
    );
  }

  assignTableFields(pageNo, perPage, data) {
    this.tableDetails = {
      ...this.tableDetails, paginationDetails: {
        totalItems: this.totalCount,
        itemsPerPage: perPage,
        currentPage: pageNo + 1
      },
      data: data,
    }
  }


  GetTransactionListDownload(
    searchValue = this.searchValue,
    pageNo: number = 0,
    filterObject: any = this.filterObj,
    perPage: any = this.noOfPages,
    Id,
    CompanyId
  ) {

    Helpers.setLoading(true);
    localStorage.setItem('perPage', perPage);


    this.payload.PageNo = pageNo;
    this.payload.PerPage = this.totalCount;
    this.payload.SearchValue = searchValue;
    this.payload.CompanyId = (CompanyId !== undefined && CompanyId !== null) ? CompanyId : this.CompanyId;

    this.payload.OrderNo = null;

    if (this.parentTypearray.includes('supplier') || this.parentTypearray.includes('manufacturer') || this.parentTypearray.includes('General Trade') || this.parentTypearray.includes('Customer')) {
      this.payload.SupplierName = Id ? Id : this.Id;
    }
    else {
      this.payload.SupplierName = null;
    }

    this.payload.ShipTo = null;
    this.payload.AllocationStatus = null;
    this.payload.FromDate = this.data.FromDate;
    this.payload.ToDate = this.data.ToDate;
    this.payload.Status = null;
    this.payload.UserId = this.userId;

    if (this.referenceType == 'Users') {
      this.payload.salesPersonId = Id ? Id : this.Id;
    }
    else {
      this.payload.salesPersonId = null;
    }

    this.payload.tabId = Id ? Id : this.Id;
    this.payload.tabreferenceType = this.referenceType;


    this._appService.Post("so_GoodsOutward", "so_rtn_GetOrdersList_Download", this.payload).subscribe((response) => {
      this.DownloadFile(response);
      Helpers.setLoading(false);
    },
      (error) => {
        Helpers.setLoading(false);
        this.toastr.error("Error while downloading", error);
      }
    );
  }

  DownloadFile(FileContent) {
    var byteNumbers = new Array(FileContent.Content.length);
    for (var i = 0; i < FileContent.Content.length; i++) {
      byteNumbers[i] = FileContent.Content.charCodeAt(i);
    }
    var blob = this.commonService.b64toBlob(FileContent.Content, FileContent.ContentType);
    let url = window.URL.createObjectURL(blob);
    $("#DownLoadFileTyreReport").attr('href', url);
    $("#DownLoadFileTyreReport").attr('download', FileContent.FileName);
    let element: HTMLElement = document.getElementById("DownLoadFileTyreReport") as HTMLElement;
    element.attributes
    element.click();
  }

}
